<template>
  <layout-default :hide-footer-mobile="true">
    <steps-header :current-step="2"></steps-header>

    <div
        class="step-2-content"
        data-aos="fade-left"
        data-aos-duration="1500"
        data-aos-once="true"
    >

      <div class="pdv-container">
        <div class="custom-padding">

          <div class="div-alinear md-5 relative">
            <div class="item1">
              <div class="row">
                <div class="col-12 m-title">
                  <h4 class="h4-header-title">Tus clases online comienzan aquí</h4>
                  <p class="p-subtitule-title">
                    Selecciona en pocos pasos tu sede, mes de inicio de tus clases y los cursos que deseas tomar.
                  </p>
                </div>
              </div>
              <div class="seccion-separator"></div>

              <div class="row">
                <div class="col-12">
                  <div class="row justify-content-md-between">
                    <div class="col-md-12">
                      <form
                        class="select-schedule-form"
                        @submit.prevent="saveSelectedSchedule"
                        :key="index"
                        v-for="(subject, index) in subjectsSchedules"
                        ref="programInscription"
                        id="programInscription"
                      >
                        <div v-if="activeSubjectIndex === index">
                          <div class="schedule-list pdv-form-group">
                            <div id="scheduleList">
                              <div class="schedule-select-title">
                                <p class="mb-3">Elige el horario que más te acomode</p>

                                <div class="d-flex align-items-center program-name ml-1">
                                  <img :src="subject.iconSrc" alt="" />
                                  <div class="d-flex flex-col">
                                    <div>
                                      <span class="ml-1">{{subject.displayName}}</span>
                                      <span
                                          class="badge-subject"
                                          v-if="subject.hasMention && !subject.displayName.toLowerCase().includes('electivo')"
                                          :style="{ border: `solid 1px ${subject.color}`, color: subject.color, background: subject.fondo }"
                                      >
                                        Mención
                                      </span>
                                      <span
                                          class="badge-subject"
                                          v-if="subject.common"
                                          :style="{ border: `solid 1px ${subject.color}`, color: subject.color, background: subject.fondo }"
                                      >Común</span>
                                    </div>
                                    <div>
                                      <span class="courses-number">{{ subject.daysArray.length }} clases por semana</span>
                                    </div>

                                  </div>
                                  
                                  <router-link
                                    :to="{ name: 'Step1' }"
                                    class="boton-new-terciario boton-new-pequeno ml-4"
                                  >
                                    {{
                                      `CAMBIAR ${
                                          !selectedProgram.isPdvX ? 'SEDE Y' : ''
                                      } CURSOS SELECCIONADOS`
                                    }}
                                  </router-link>
                        
                                </div>
                              </div>                                
                              <div class="seccion-separator"></div>
                              <div class="row position-relative">
                                <div class="col-md-12">
                                  <div class="row">
                                    <div 
                                      class="custom-acordeon col-12 col-md-6 col-sm-12 col-xs-12 mb-4"
                                      :class="{'m-ac': index != (subject.daysArray.length - 1) }"
                                      :key="index"
                                      v-for="(schedule, index) in subject.schedules"
                                    >
                                      <div class="accordion h-full" :id="'accordionInfo-'+ index">
                                        <div class="card">
                                          <div class="card-header" :id="'heading' + index">
                                            <div
                                              class="acordeon-button"
                                              data-toggle="collapse" 
                                              :data-target="'#collapseOne'+ index" 
                                              :aria-expanded="index === 0 ? true : false" 
                                              :aria-controls="'collapseOne'+ index"
                                            >
                                              <p>
                                                {{ schedule.weekDaysGroup }}
                                              </p>
                                              <img
                                                src="/images/featured/down-acordeon-arrow.svg"
                                                alt="down-acordeon-arrow"
                                              />
                                            </div>
                                          </div>

                                          <div
                                            :id="'collapseOne' + index"
                                            class="collapse show"
                                            :data-parent="'#accordionInfo-'+ index"
                                            :aria-labelledby="'heading' + index"
                                          >
                                            <div class="card-body">
                                              <div
                                                class="custom-radio-cont position-relative"
                                                :class="{disabled:hour.coursesWithSameSchedule.length}"
                                                :key="indexHour"
                                                v-for="(hour, indexHour) in schedule.hours"
                                              >
                                                <input
                                                    type="radio"
                                                    @change="hourSelected = true"
                                                    :value="hour"
                                                    v-model="courseSelected"
                                                    :id="
                                                    'Option' + indexHour + 'Schedule' + index
                                                  "
                                                  name="horario"
                                                />
                                                <img
                                                    class="hover-selector-icon"
                                                    src="/images/iconos/Flecha-derecha.svg"
                                                    alt=""
                                                />
                                                <label
                                                  @click="ErrorSubmit = false"
                                                  :for="'Option' + indexHour + 'Schedule' + index"
                                                  class="radio-label"
                                                >

                                                <div class="d-flex mb-1">
                                                  <div class="pdv-custom-radio">
                                                    <img
                                                      src="images/iconos/radio-selected.svg"
                                                      alt=""
                                                    />
                                                  </div>
                                                  <span> {{ getSchedule(hour.hoursPerDay)}} </span>
                                                </div>
                                                  <span
                                                    style="margin-left: 3px"
                                                    v-if="hour.coursesWithSameSchedule.length"
                                                  >
                                                    - Reservado
                                                    <span
                                                      v-for="(previousSelectedCourse,
                                                      idx) in hour.coursesWithSameSchedule"
                                                      :key="idx"
                                                    >
                                                      <img
                                                        class="previous-selected-course-icon"
                                                        :src="previousSelectedCourse.iconSrc"
                                                        alt=""
                                                      />
                                                      {{previousSelectedCourse.subjectName + ' '}}
                                                    </span>
                                                  </span>
                                                  <div
                                                    class="alert-message"
                                                    v-if="hour.lastSeats"
                                                    v-inview:class="['animated', 'flash']"
                                                  >
                                                    <img
                                                      src="images/featured/warning.svg"
                                                      alt=""
                                                    />
                                                    <span class="texto">Últimos cupos</span>
                                                  </div>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> 
                                    </div>
                                  </div>

                                  <!--div class="row">
                                    <div class="col"> 
                                      <div>
                                        <div class="d-md-flex align-items-center mb-4">

                                          <router-link
                                              :to="{ name: 'Step1' }"
                                              class="boton-new-terciario boton-new-pequeno ml-1"
                                          >{{
                                              `CAMBIAR ${
                                                  !selectedProgram.isPdvX ? 'SEDE Y' : ''
                                              } CURSOS SELECCIONADOS`
                                            }}</router-link
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div-->

                                  <div class="pdv-submit-button">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div
                                            class="form-group d-md-flex align-items-md-center"
                                        >
                                          <button
                                            type="submit"
                                            :disabled="!hourSelected"
                                            class="boton-new-primario boton-new-mediano"
                                          >
                                            CONFIRMAR HORARIO DE
                                            <span class="pdv-text-uppercase ml-1">{{subject.displayName}}</span>
                                          </button>

                                          <div
                                              class="box-error-activator"
                                              @click="ErrorSubmit = true"
                                              :class="{ 'd-none': hourSelected }"
                                          ></div>
                                          <div
                                              class="error-message-submit"
                                              v-if="ErrorSubmit"
                                          >
                                            <img
                                                src="/images/iconos/icon-alert-red.svg"
                                                alt=""
                                            />
                                            <span
                                            >Aún debes seleccionar el horario de tu
                                              curso de {{ subject.displayName }}</span
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  

                </div>
              </div>

            </div>
            <div class="item2">
              <img
                src="/images/featured/gorl-imagin-book-idea.svg"
                alt="gorl-imagin-book-idea"
                class="imagen-pensar"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <delete-course-modal
        @buttonDeleteSubjectPressed="deleteCurrentSubject"
        :currentSubject="subjectsSchedules[activeSubjectIndex]"
    ></delete-course-modal>
    <button
        id="showDeleteCourseModal"
        data-toggle="modal"
        data-target=".delete-course-modal"
        data-backdrop="static"
        data-keyboard="false"
    >
      Modal
    </button>
  </layout-default>
</template>

<script>
import LayoutDefault from '@/layouts/Default';
import localPageTimerMixin from '@/mixins/localPageTimerMixin';
import StepsHeader from '@/components/StepsHeader';
import formValidation from '@/mixins/formValidation';
import deleteCourseModal from '@/components/modals/deleteCourseModal';
import { mapActions, mapState } from 'vuex';

const $ = window.$;
export default {
  components: {
    LayoutDefault,
    StepsHeader,
    deleteCourseModal
  },

  data() {
    return {
      weekDaysSorter: {
        lunes: 1,
        martes: 2,
        miércoles: 3,
        jueves: 4,
        viernes: 5,
        sábado: 6,
        domingo: 7
      },
      lastSeatsThreshold: 10,
      blocks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      activeSubjectIndex: 0,
      subjectsSchedules: [],
      hourSelected: false,
      ErrorSubmit: false,
      courseSelected: null,
      selectedCoursesByDay: [],
      coursesFromApi: null
    };
  },

  computed: {
    ...mapState(['coursesNotAvailables']),
    selectedSubjects() {
      const selectedSubject = this.$store.state.selectedSubjects;
      return selectedSubject.sort((a, b) => {
        let subject1 = a.courses.length;
        let subject2 = b.courses.length;
        return subject1 - subject2;
      });
    },
    selectedLocation() {
      return this.$store.state.selectedLocation;
    },
    selectedCourses() {
      return this.$store.getters.lastStudent.selectedCourses;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    pendingCourses() {
      let pendingCourses = this.selectedSubjects;
      this.selectedCourses.forEach((sc) => {
        pendingCourses = pendingCourses.filter(
            (pc) => pc.name !== sc.subjectName
        );
      });
      return pendingCourses;
    }
  },

  mixins: [formValidation, localPageTimerMixin],

  async mounted() {
    $('.schedule-list-content-container').on('show.bs.collapse', function() {
      $(this)
          .closest('.schedule-list-item')
          .addClass('open');
    });

    $('.schedule-list-content-container').on('hidden.bs.collapse', function() {
      $(this)
          .closest('.schedule-list-item')
          .removeClass('open');
    });

    // if(this.coursesNotAvailables){
    //     // const student = this.$store.getters.lastStudent;
    //     // const coursesNotAvailables = this.coursesNotAvailables.find(x=>x.student.id === student.id)
    //     this.$store.dispatch('addSubject',...this.selectedSubjects);
    //     this.$store.dispatch("addSubjectWithCourses", subjectAndCourses);
    // }
    this.$store.dispatch('clearSelectedCourses');

    const { data } = await this.Axios.get(
        `/courses?programId=${this.selectedProgram.id}&locationId=${this.selectedLocation.id}`
    );
    this.coursesFromApi = data;
    this.mapSelectedSubjects();
    this.loadAllSchedules();
    this.loadSelectedCoursesByDay();
    /* console.log(this.subjectsSchedules); */
  },

  methods: {
    ...mapActions(['setInitialSubject']),


    mapSelectedSubjects() {
      let selectedSubjects = this.selectedSubjects.map((sc) => {
        sc.courses = sc.courses.map((cfa) => {
          return this.coursesFromApi.find((c) => c.id === cfa.id);
        });
        sc.courses = sc.courses.filter((c = {}) => c && c.seatsAvailable);
        return sc;
      });
      localStorage.setItem(
          'selectedSubjects',
          JSON.stringify(selectedSubjects)
      );
      this.setInitialSubject();
    },
    async saveSelectedSchedule() {
      this.activeSubjectIndex++;
      let subjectPendingToSelectSchedule =
          this.activeSubjectIndex < this.subjectsSchedules.length;

      // Collect selected course
      await this.$store.dispatch('saveCourseSelected', this.courseSelected);
      await this.clearSubjectsSchedules();

      this.loadAllSchedules();
      this.loadSelectedCoursesByDay();

      if (subjectPendingToSelectSchedule) {
        this.hourSelected = false;
        this.checkIfThereIsAvailableSchedule();
      } else {
        this.goToNextStep();
      }
    },
    goToNextStep() {
      this.$router.push({ name: 'Step3' });
    },
    clearSubjectsSchedules() {
      return new Promise((resolve) => {
        this.subjectsSchedules = [];
        resolve();
      });
    },
    loadAllSchedules() {
      this.selectedSubjects.forEach((currentSubject) => {
        let subject = {
          ...currentSubject,
          schedules: []
        };
        let daysGroupsArray = [];
        let hoursArray = [];

        currentSubject.courses.forEach((currentCourse) => {
          if (!currentCourse.Schedules.length) {
            return;
          }
          let daysGroupOfThisCourse = [];

          let daysGroupsWithHours = {};

          let blocksOfThisCourse = [];

          let hoursPerDay = [];

          currentCourse.Schedules.forEach((currentSchedule) => {
            daysGroupOfThisCourse.push(currentSchedule.dayOfWeek);

            blocksOfThisCourse.push(currentSchedule.block);

            this.blocks.forEach((block) => {
              if (currentSchedule.block == block) {
                if (daysGroupsWithHours[block]) {
                  daysGroupsWithHours[block].days = [
                    ...daysGroupsWithHours[block].days,
                    currentSchedule.dayOfWeek
                  ];
                  daysGroupsWithHours[block].daysSmallVersion = [
                    ...daysGroupsWithHours[block].daysSmallVersion,
                    currentSchedule.dayOfWeek.substring(0, 3)
                  ];
                } else {
                  daysGroupsWithHours[block] = {};
                  daysGroupsWithHours[block].days = [currentSchedule.dayOfWeek];
                  daysGroupsWithHours[block].daysSmallVersion = [
                    currentSchedule.dayOfWeek.substring(0, 3)
                  ];
                  daysGroupsWithHours[block].time =
                      currentSchedule.startTime.slice(0, -3) +
                      ' a ' +
                      currentSchedule.endTime.slice(0, -3);
                  daysGroupsWithHours[
                      block
                      ].startTime = currentSchedule.startTime.slice(0, -3);
                }
              }
            });

            hoursPerDay.push({
              day: currentSchedule.dayOfWeek,
              startTime: currentSchedule.startTime,
              endTime: currentSchedule.endTime,
              subject: currentSubject.name,
              block: currentSchedule.block
            });
          });

          daysGroupsArray.push(daysGroupOfThisCourse);

          let daysGroupsWithHoursArray = Object.values(daysGroupsWithHours);
          let daysGroupsWithHoursArraySorted = daysGroupsWithHoursArraySorter(
              this.weekDaysSorter
          );

          function daysGroupsWithHoursArraySorter(weekDaysSorter) {
            let daysGroupsWithHoursArraySorted = [];
            Object.keys(weekDaysSorter).forEach((sorterDay, index) => {
              daysGroupsWithHoursArraySorted[index] = null;
              daysGroupsWithHoursArray.forEach((scheduleItem) => {
                if (sorterDay === scheduleItem.days[0].toLowerCase()) {
                  daysGroupsWithHoursArraySorted[index] = scheduleItem;
                }
              });
            });
            return daysGroupsWithHoursArraySorted.filter(
                (scheduleItem) => scheduleItem
            );
          }

          let schedulesPerDayOfThisCourse = [];
          daysGroupsWithHoursArraySorted = daysGroupsWithHoursArraySorted.map(
              (item) => {
                let weekDaysGroupString = item.daysSmallVersion.join(', ');
                weekDaysGroupString = weekDaysGroupString.replace(
                    /(, )([\wáéíóú]+)$/,
                    ' y $2'
                );

                item.days.forEach((day) => {
                  schedulesPerDayOfThisCourse.push(`${day} ${item.time}`);
                });

                return {
                  ...item,
                  fullSchedule: weekDaysGroupString + ' ' + item.time
                };
              }
          );

          let fullScheduleString = daysGroupsWithHoursArraySorted
              .map((item, index, array) => {
                let isTheLastItem = array.length - 1 === index;
                let isTheSecondLast = array.length - 2 === index;

                if (isTheSecondLast) {
                  return item.fullSchedule + ' y ';
                } else if (isTheLastItem) {
                  return item.fullSchedule;
                } else {
                  return item.fullSchedule + ', ';
                }
              })
              .join('');
          //console.log('Curso Id: ' + currentCourse.id);
          let hour = {
            courseId: currentCourse.id,
            hour: fullScheduleString,
            lastSeats: currentCourse.seatsAvailable < this.lastSeatsThreshold,
            days: daysGroupOfThisCourse,
            subjectName: currentSubject.name,
            iconSrc: currentSubject.iconSrc,
            coursePdvId: currentCourse.pdvId,
            coursePdvCode: currentCourse.pdvCode,
            subjectId: currentCourse.subjectId,
            blocks: blocksOfThisCourse,
            schedulesPerDayOfThisCourse: schedulesPerDayOfThisCourse,
            coursesWithSameSchedule: [],
            hoursPerDay: hoursPerDay
          };

          let previousSelectedCourses = this.$store.getters.lastStudent
              .selectedCourses;
          if (previousSelectedCourses) {
            previousSelectedCourses.forEach((course) => {
              course.schedulesPerDayOfThisCourse.forEach((schedule) => {
                if (schedulesPerDayOfThisCourse.includes(schedule)) {
                  let alreadyInArray = hour.coursesWithSameSchedule.find(
                      (courseWithSameSchedule) =>
                          courseWithSameSchedule.subjectName === course.subjectName
                  );
                  if (!alreadyInArray) {
                    hour.coursesWithSameSchedule.push({
                      subjectName: course.subjectName,
                      iconSrc: course.iconSrc
                    });
                  }
                }
              });
            });
          }

          hoursArray.push(hour);
        });

        daysGroupsArray = daysGroupsArray.map((daysGroup) => {
          return daysGroup.sort((a, b) => {
            let day1 = a.toLowerCase();
            let day2 = b.toLowerCase();
            return this.weekDaysSorter[day1] - this.weekDaysSorter[day2];
          });
        });
        let daysGroupsArrayFiltered = [];
        daysGroupsArray.forEach((daysGroup) => {
          let itemInArray = daysGroupsArrayFiltered.find((item) => {
            return item.join(',') === daysGroup.join(',');
          });

          if (!itemInArray) {
            daysGroupsArrayFiltered.push(daysGroup);
          }
        });

        daysGroupsArrayFiltered = daysGroupsArrayFiltered.sort((a, b) => {
          let day1 = a[0].toLowerCase();
          let day2 = b[0].toLowerCase();
          return this.weekDaysSorter[day1] - this.weekDaysSorter[day2];
        });

        daysGroupsArrayFiltered.forEach((daysGroup) => {
          let weekDaysGroupString = daysGroup.join(', ');
          weekDaysGroupString = weekDaysGroupString.replace(
              /(, )([\wáéíóú]+)$/,
              ' y $2'
          );

          let hoursArrayFiltered = [];
          hoursArray.forEach((hour) => {
            let hourDays = hour.days.join(', ');
            hourDays = hourDays.replace(/(, )([\wáéíóú]+)$/, ' y $2');

            if (hourDays === weekDaysGroupString) {
              hoursArrayFiltered.push(hour);
            }
          });

          subject.daysArray = daysGroup;

          subject.schedules.push({
            weekDaysGroup: weekDaysGroupString,
            open: false,
            hours: hoursArrayFiltered
          });
        });
        this.subjectsSchedules.push(subject);
      });
    },

    loadSelectedCoursesByDay() {
      let days = [];

      let selectedCourses = this.selectedCourses;

      selectedCourses.forEach((currentCourse) => {
        currentCourse.hoursPerDay.forEach((currentHourPerDay) => {
          let dayIsInArray = days.find(
              (day) => day.name === currentHourPerDay.day
          );
          if (!dayIsInArray) {
            days.push({
              name: currentHourPerDay.day,
              subjects: []
            });
          }
        });
      });

      days.sort((a, b) => {
        let day1 = a.name.toLowerCase();
        let day2 = b.name.toLowerCase();
        return this.weekDaysSorter[day1] - this.weekDaysSorter[day2];
      });

      days.forEach((day, dayIndex) => {
        this.selectedCourses.forEach((currentCourse) => {
          currentCourse.hoursPerDay.forEach((currentHourPerDay) => {
            if (day.name === currentHourPerDay.day) {
              days[dayIndex].subjects.push({
                startTime: currentHourPerDay.startTime,
                endTime: currentHourPerDay.endTime,
                name: currentHourPerDay.subject,
                block: currentHourPerDay.block
              });
            }
          });
        });
      });

      days.map((day) => {
        day.subjects.sort((a, b) => {
          let block1 = a.block;
          let block2 = b.block;
          return block1 - block2;
        });
        return day;
      });

      this.selectedCoursesByDay = days;

    },

    checkIfThereIsAvailableSchedule() {
      let allHours = [];
      let reservedHours = [];

      this.subjectsSchedules[this.activeSubjectIndex].schedules.forEach(
          (dayGroup) => {
            dayGroup.hours.forEach((hour) => {
              allHours.push(hour);
              if (hour.coursesWithSameSchedule.length) {
                reservedHours.push(hour);
              }
            });
          }
      );

      if (allHours.length === reservedHours.length) {
        setTimeout(() => {
          $('#showDeleteCourseModal').trigger('click');
        }, 0);
      } else {
        //console.log('Hay cupos');
      }
    },

    async deleteCurrentSubject() {
      this.subjectsSchedules.splice(this.activeSubjectIndex, 1);

      await this.$store.dispatch('removeSubject', this.activeSubjectIndex);

      $('#closeDeleteCourseModalButton').trigger('click');
      let subjectPendingToSelectSchedule =
          this.activeSubjectIndex < this.subjectsSchedules.length;
      if (!subjectPendingToSelectSchedule) {
        this.goToNextStep();
      }
    },
    getSchedule(hoursPerDay){
      let days=""
      if (hoursPerDay.length == 1) {
        days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
      } else if (hoursPerDay.length == 2) {
        if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else {
          days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3)
        }
      } else if (hoursPerDay.length == 3) {
        if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[2].startTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[2].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3)
        } else if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[2].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[2].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[1].startTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[2].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3)
        } else if (hoursPerDay[2].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[2].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[2].startTime.slice(0, -3)) {
          days = hoursPerDay[2].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3) + " y " + hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[2].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[2].endTime.slice(0, -3)) {
          days = hoursPerDay[0].day + ", " + hoursPerDay[1].day +  " y " + hoursPerDay[2].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else {
          days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + ", " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3) + " y " + hoursPerDay[2].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3)
        }
      }
      return days
    },
  }
};
</script>

<style scoped lang="scss">

  .m-ac{
    @media (max-width: 768px) {
      margin-bottom: 32px;
    }
  }
  .boton-new-primario{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background-color: $morado50;
    border: solid 4px $neutralwhite;
    color: $neutralwhite;
    &:hover{
      background-color: $morado30;
    }
    &:active{
      background-color: $morado90;
    }
    &:focus{
      background-color: $morado50; 
      border: solid 4px grey;
    }
    &:disabled {
      background-color: #5924661a;
    }

    &.boton-new-largo{
      padding: 0 32px;
      height: 60px;
      width: auto;
      font-size: 20px;
      line-height: 28px;
    }
    &.boton-new-mediano{
      padding: 0 24px;
      height: 48px;
      width: auto;
      font-size: 16px;
      line-height: 18px;
    }
    &.boton-new-pequeno{
      padding: 0 16px;
      height: 32px;
      width: auto;
      font-size: 14px;
      line-height: 22px;

      
    }

    img{
      margin-right: 16px;
    }
  }

.seccion-separator{
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.imagen-pensar{
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.w-accordion-custom{
  @media (max-width: 768px) {
   width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding{
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.div-alinear{
    display: flex;
    gap: 40px;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    @media (min-width: 769px) {
      flex-direction: row;
    }
    .item1{
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 70%;
      }
    }
    .item2{
      @media (max-width: 768px) {
        width: 100%;
        display: none;
      }
      @media (min-width: 769px) {
        width: 30%;
      }
    }
  }
.step-2-content {
  padding-bottom: 0 !important;
  .p-subtitule-title {
    font-family: 'Poppins-Regular', sans-serif;
    margin-bottom: 0px;
    color: $neutralBlack;
    font-size: 16px;
    line-height: 24px;
  }
  .h4-header-title {
    font-family: 'Poppins-Bold', sans-serif;
    margin-bottom: 16px;
    color: $neutralBlack;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 42px;
    }
  }

  padding: 25px 0 56px;
  @include media-breakpoint-down(sm) {
    padding: 30px 0 125px;
  }

  .error-message-submit {
    position: absolute;
    left: 70%;
    z-index: 10;
    margin-top: 0;
    margin-bottom: 0;
    width: max-content;
    @include media-breakpoint-down(sm) {
      position: static;
      margin: 10px auto;
    }
  }
}

.schedule-list-items-container {
  margin-bottom: 28px;
}

.schedule-select-title {
  display: flex;
  justify-content: center;
  flex-direction: column;

  p {
    color: $neutralBlack;
    margin-bottom: 0;
    font-family: 'Poppins-Bold', sans-serif;
    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 26px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 24px;
    }
  }

  .program-name {
    span {
      margin-left: 5px;
      color: $neutralBlack;
      font-family: 'Poppins-Medium', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; 

      &.mention-flat {
        font-size: 14px;
        @include alternative-light-regular;
        padding: 0 5px;
        color: #fff;
        margin-left: 3px;
        line-height: 18px;
      }
    }

    img {
      width: 35px;
    }
  }
}

.schedule-list {
  margin-bottom: 28px;

  span.courses-number {
    color: $neutral70;
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .schedule-list-item {
    span {
      font-size: 14px;
      line-height: 16px;
      @include alternative-italic;
      color: $gray-dark;
    }
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
    @include alternative-regular;
    width: 100%;
    border: 1px solid #979797;
    background: transparent;
    transition: all 0.3s ease;

    &:last-child {
      margin-bottom: 0;
    }

    &.open {
      box-shadow: 0px 4px 10px 1px #0000001c;
    }

    .list-header {
      .btn-pdv-collapse {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border: none;

        span {
          font-size: 16px;
          line-height: 18px;
          color: #000;
          @include alternative-medium-regular;
        }

        width: 100%;

        &:not(.collapsed) img {
          transform: rotate(180deg);
        }
        &:focus {
          outline: none;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    .schedule-list-content {
      border-top: 1px solid $gray-light;
      padding: 20px 0;

      .custom-radio-cont {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .radio-label {
          span {
            @include alternative-light-regular;
          }

          
        }
      }
    }
  }
}

.alert-message {
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #B56700;
  background:#FFFAF0;
  padding: 1px 8px;
  width: 50%;
  margin-left: 29px;
  
  img {
    width: 20px;
    margin: 0 5px;
  }

  .texto {
    color: #B56700 !important;
    font-family: 'Poppins-Medium', sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    line-height: 22px !important; 
    margin-bottom: 0 !important;
  }
}

.widget-info {
  padding-left: 19px;
  border-left: 1px solid rgba($gray-light, 0.4);

  .widget-title {
    display: flex;
    align-items: center;
    margin-bottom: 19px;

    h4 {
      font-size: 12px;
      letter-spacing: 2px;
      line-height: 22px;
      margin-bottom: 0;
      margin-left: 8px;
      @include alternative-regular;
    }
  }

  .widget-body {
    .widget-body-item {
      margin-bottom: 34px;

      h5 {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 19px;
        @include alternative-medium-regular;
      }

      .main-info {
        padding-left: 0;
        margin-bottom: 34px;

        li {
          padding-bottom: 20px;
          list-style: none;
          position: relative;

          p {
            line-height: 16px;
            font-size: 14px;
            @include alternative-light-regular;
            position: relative;
            padding-left: 18px;
            color: $gray-dark;
            margin-bottom: 0;

            .hour {
              color: $gray-dark;
              line-height: 16px;
              font-size: 14px;
              @include alternative-light-regular;
            }

            &:before {
              content: '';
              width: 6px;
              height: 6px;
              background: $gray-light;
              border-radius: 50%;
              position: absolute;
              left: 2px;
              top: 50%;
              transform: translateY(-50%);
            }
          }

          &:before {
            content: '';
            width: 1px;
            height: 100%;
            position: absolute;
            background: $gray-light;
            left: 4px;
            top: 10px;
          }

          &:first-child {
            p:before {
              content: '';
              width: 10px;
              height: 10px;
              left: 0;
            }
          }

          &:last-child {
            padding-bottom: 0;

            p:before {
              content: '';
              width: 10px;
              height: 10px;
              left: 0;
            }

            &:before {
              display: none;
            }
          }

          &:first-child {
            .hour:first-child {
              @include alternative-bold;
            }
          }

          &:last-child {
            .hour:last-child {
              @include alternative-bold;
            }
          }
        }
      }
      .main-info.course-list {
        margin-bottom: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.box-error-activator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.pdv-text-uppercase {
  font-family: inherit;
  font-size: inherit;
}

.custom-radio-cont {
  &.disabled {
    cursor: default;
    pointer-events: none;

    .pdv-custom-radio {
      visibility: hidden;
    }

    .radio-label {
      cursor: default;
      span {
        color: $gray;
      }
    }
  }
}

.schedule-list .schedule-list-item .schedule-list-content {
  .custom-radio-cont {
    margin-bottom: 0;
    padding: 15px 20px;
    &:hover {
      background: rgba(255, 237, 192, 0.41);
      .hover-selector-icon {
        display: inline-block;
      }
    }
  }
}

.pdv-form-group .custom-radio-cont .radio-label {
  margin-bottom: 0;
  .pdv-custom-radio {
    background: #fff;
  }
}

.hover-selector-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  width: 7px;
}

.previous-selected-course-icon {
  filter: grayscale(100%);
  height: 22px;
  position: relative;
  top: -1px;
  opacity: 0.7;
}
.schedule-list-item {
  max-width: 540px;
}

#showDeleteCourseModal {
  position: absolute;
  visibility: hidden;
}

.badge-subject{
  font-family: 'Poppins-Medium', sans-serif !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  padding: 1px 8px !important;
  border-radius: 8px !important;
}
</style>
